import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div className="bg-gray-100 py-16">
      <div className="container lg:flex lg:text-center lg:justify-between">
        <div className="lg:w-1/3">
          <div className="flex">
            <i className="fas fa-tooth text-4xl text-primary"></i>
            <span className="text-2xl font-Poppins">
              Lirza Dental <span className="text-primary">Care</span>
            </span>
          </div>
          <p className="text-justify py-4">
            Ne krenohemi shumë me
            cilësinë e punës sonë. ne e kuptojmë se çfarë klienti i plotë
            kënaqësi do të thotë kënaqësi e klientit.
          </p>
          <div className="text-primary text-2xl flex">
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.facebook.com/LirzaDental.al"
            >
              <i className="fab fa-facebook-square ml-2"></i>
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.instagram.com/lirza_dental/"
            >
              <i className="fab fa-instagram-square  ml-2"></i>
            </a>
          </div>
        </div>
        <div className="w-1/3 lg:py-0 py-8">
          <h1 className="text-2xl font-Poppins">Më shumë info</h1>
          <ul className="py-4">
            <li className="py-1 hover:text-primary">
              <Link to="/">Faqja kryesore</Link>
            </li>
            <li className="py-1 hover:text-primary">
              <Link to="/about">Rreth nesh</Link>
            </li>
            <li className="py-1 hover:text-primary">
              <Link to="/services">Shërbimet</Link>
            </li>
            <li className="py-1 hover:text-primary">
              <Link to="/contact">Na kontaktoni</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
